import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function ResupplysModule() {
  return <ModuleNavigation moduleId="ResupplysModule" />;
}
